export {default} from '../../../core/components/Repository/PageDetailTabs';